module.exports = {"id":"216020","name":"Leonardo Gil","rating":"71","photo":"./data/images/photos/4/216020.png","club":{"name":"Rosario Central","logo":"./data/images/clubs/RosarioCentral.png"},"positions":["MC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LeonardoGil0.json
// module id = 2487
// module chunks = 0